import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";

/* =========================
   TEST MODE APIs
========================= */
const instructionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/testdetails";

const examQuestionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_single_question";

const examAllQuestionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/allquestionlist";

const saveAnswerApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_single_save";

const submitExamApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_submit";

/* =========================
   PRACTICE MODE APIs
========================= */
const instructionPracticeApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/pyq_subjecttopic_instruction";

const examAllQuestionPracticeApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/allquestionlist_practice";

const saveAnswerPracticeApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_singlesave_practice";

const submitExamPracticeApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_submit_practice";

  const practiceSummaryApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/examtest_summary";


/* =========================
   COMMON APIs
========================= */
const practiceApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/user/practicelist";

const bookmarkApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/saveBookmark";

const pyqYearWise =
  "https://learning.motion.ac.in/motioneducation/api/v1/pyqyearlist";

const pyqYearwisePaperApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/pyq_yearwise_paper";

// const pyqTopicWisePaperApi =
//   "https://learning.motion.ac.in/motioneducation/api/user/UserSubjectOTS";

const pyqSubjectWiseApi =
  // "https://learning.motion.ac.in/motioneducation/api/user/pyqSubjectWiseTopics";
  "https://learning.motion.ac.in/motioneducation/api/v1/pyq_subjectwise_topic";
const pyqTopicWiseSetApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/getTopicWisePracticeSets";

const subjectListApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/subjectlist";

/* =========================
   API OBJECT
========================= */
const examApi = {
  getPyqYearWise: async ({ topic }) => {
    const res = await axioInstance.get(`${pyqYearWise}?topic=${topic}`);
    return res.data;
  },

  getPyqYearwisePapers: async ({ year, target }) => {
    const res = await axioInstance.get(
      `${pyqYearwisePaperApi}?year=${year}&target=${target}`
    );
    return res.data;
  },

  getInstruction: async ({
    paperType,
    paperId,
    plannerId,
    testId,
    setId,
    practiceMode,
     gamificationOn,
  }) => {
    const isTopicwise = !!setId;
    const apiUrl =
      // practiceMode === "practice"
       isTopicwise && practiceMode === "practice" && gamificationOn
        ? instructionPracticeApi
        : instructionApi;

    const res = await axioInstance.get(
      `${apiUrl}?paper_type=${paperType}&test_id=${testId}&planner_id=${plannerId}&paper_id=${paperId}&set_id=${setId}`
    );

    return res.data;
  },

  getQuestion: async ({
    paperType,
    paperId,
    qid,
    testId,
    setId,
    plannerTestId,
  }) => {
    const res = await axioInstance.get(
      `${examQuestionApi}?paper_type=${paperType}&paper_id=${paperId}&qid=${qid}&test_id=${testId}&set_id=${setId}&planner_test_id=${plannerTestId}`
    );
    return res.data;
  },

  getQuestionList: async ({
    paperType,
    paperId,
    testId,
    setId,
    practiceMode,
    gamification_status,
  }) => {
    const apiUrl =
      practiceMode === "practice"
        ? examAllQuestionPracticeApi
        : examAllQuestionApi;

    const res = await axioInstance.get(
      `${apiUrl}?paper_type=${paperType}&paper_id=${paperId}&test_id=${testId}&set_id=${setId}${
        practiceMode === "practice" && gamification_status === 1
          ? `&gamification_status=1`
          : ""
      }`
    );

    return res;
  },

  getPracticeList: async () => {
    const res = await axioInstance.get(practiceApi);
    return res;
  },

  saveAnswer: async (payload) => {
    const apiUrl =
      payload.practiceMode === "practice"
        ? saveAnswerPracticeApi
        : saveAnswerApi;

    const finalPayload =
      payload.practiceMode === "practice" && payload.gamification_status === 1
        ? { ...payload, gamification_status: 1 }
        : payload;

    const res = await axioInstance.post(apiUrl, finalPayload);
    return res.data;
  },

  submitExam: async ({
    paperType,
    paperId,
    testId,
    setId,
    time,
    practiceMode,
    gamification_status,
  }) => {
    const apiUrl =
      practiceMode === "practice"
        ? submitExamPracticeApi
        : submitExamApi;

    const res = await axioInstance.post(
      `${apiUrl}?paper_type=${paperType}&paper_id=${paperId}&set_id=${setId}&test_id=${testId}&time=${time}${
        practiceMode === "practice" && gamification_status === 1
          ? `&gamification_status=1`
          : ""
      }`
    );

    return res.data;
  },

  saveBookmark: async ({ type, status, reference_id }) => {
    const res = await axioInstance.post(
      `${bookmarkApi}?type=${type}&status=${status}&reference_id=${reference_id}`
    );
    return res.data;
  },

  subjectList: async ({ category_id }) => {
    const res = await axioInstance.get(
      `${subjectListApi}?category_id=${category_id}`
    );
    return res.data;
  },

  // topicWise: async ({ course_id, class_id }) => {
  //   const res = await axioInstance.post(
  //     `${pyqTopicWisePaperApi}?course_id=${course_id}&class_id=${class_id}`
  //   );
  //   return res.data;
  // },

  subjectWise: async ({ subject,paper_type}) => {
    const encodedSubject = encodeURIComponent(subject ?? "");
    const encodedPaperType = encodeURIComponent(paper_type ?? "");
    const res = await axioInstance.post(
      `${pyqSubjectWiseApi}?subject=${encodedSubject}&paper_type=${encodedPaperType}`
    );
    return res.data;
  },

  subjectWiseSet: async ({ subject, topic, format }) => {
    const encodedSubject = encodeURIComponent(subject ?? "");
    const encodedTopic = encodeURIComponent(topic ?? "");
    const encodedFormat = encodeURIComponent(format ?? "");
    const res = await axioInstance.post(
      `${pyqTopicWiseSetApi}?subject=${encodedSubject}&topic=${encodedTopic}&format=${encodedFormat}`
    );
    return res.data;
  },

  getPyqTopicWiseSets: async ({ subject, topic,format }) => {
    const encodedSubject = encodeURIComponent(subject ?? "");
    const encodedTopic = encodeURIComponent(topic ?? "");
    const encodedFormat = encodeURIComponent(format ?? "");
    const res = await axioInstance.post(
      `${pyqTopicWiseSetApi}?subject=${encodedSubject}&topic=${encodedTopic}&format=${encodedFormat}`
    );
    return res.data;
  },

getPracticeSummary: async ({
  paperType,
  paperId,
  setId,
  gamification_status,
}) => {
  let query = `paper_type=${paperType}`;

  // ✅ behave like getInstruction, but SAFE
  query += `&paper_id=${paperId}`;
  query += `&set_id=${setId}`;

  if (gamification_status === 1) {
    query += `&gamification_status=1`;
  }

  const res = await axioInstance.get(
    `${practiceSummaryApi}?${query}`
  );

  return res.data;
},


};

export default examApi;
